// extracted by mini-css-extract-plugin
export default {"container":"BdowHX","spin":"jsuS6N","icon":"MajHCS"};